<template>
  <div>
    <AppToolbar
      :title="organization ? organization.name : ''"
      :prev-route="$security.getUserOrganizations().length > 1 ? { name: 'OrganizationList' } : null"
      :toggle-drawer="$vuetify.breakpoint.smAndDown"
      @toggleDrawer="$emit('toggleDrawer')"
    >
      <template slot="buttons">
        <v-btn v-if="isShipowner" text icon @click="showOrganizationUpdateDialog = true">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <ToolbarView
          :map-route="{
            name: 'OrganizationShowMap',
            params: { id: $route.params.id }
          }"
        ></ToolbarView>
      </template>
      <v-tabs slot="tabs" v-model="selectedTab" centered background-color="blue" slider-color="warning">
        <v-tab key="tab-vessels" href="#tab-vessels" active>
          {{ $t('message.vessels') }}
        </v-tab>

        <v-tab key="tab-employees" href="#tab-employees">
          {{ $t('message.employees') }}
        </v-tab>
      </v-tabs>
    </AppToolbar>

    <template v-if="error">
      <GenericError />
    </template>

    <template v-else>
      <v-tabs-items v-model="selectedTab" class="fill-height has-fab">
        <v-tab-item key="tab-vessels" value="tab-vessels" class="fill-height">
          <VesselList v-if="organization" :organization="organization"></VesselList>
        </v-tab-item>
        <v-tab-item key="tab-employees" value="tab-employees" class="fill-height">
          <RoleInOrganizationList v-if="organization" :organization="organization"></RoleInOrganizationList>
        </v-tab-item>
      </v-tabs-items>
    </template>

    <OrganizationDialog
      :show="showOrganizationUpdateDialog"
      :organization="organization"
      @close="showOrganizationUpdateDialog = false"
    ></OrganizationDialog>
  </div>
</template>

<script>
import GenericError from '@/components/error/GenericError'
import { mapActions, mapGetters } from 'vuex'
import AppToolbar from '@/components/AppToolbar'
import VesselList from '@/components/vessel/List'
import RoleInOrganizationList from '@/components/roleinorganization/List'
import OrganizationDialog from '@/components/organization/dialog/Dialog'
import ToolbarView from '@/components/ToolbarView'

export default {
  components: {
    ToolbarView,
    OrganizationDialog,
    GenericError,
    AppToolbar,
    VesselList,
    RoleInOrganizationList
  },

  data: () => ({
    selectedTab: null,
    isShipowner: false,
    showOrganizationUpdateDialog: false
  }),

  computed: mapGetters({
    error: 'organization/show/error',
    organization: 'organization/show/retrieved',
    organizationLoading: 'organization/show/isLoading'
  }),

  created() {
    this.$store.commit('mapSetShow', false)
    this.getOrganization('/organizations/' + this.$route.params.id)
    this.isShipowner = this.$security.isGranted('/organizations/' + this.$route.params.id, 'ROLE_SHIPOWNER')
  },

  methods: {
    ...mapActions({
      getOrganization: 'organization/show/retrieve'
    })
  }
}
</script>
